import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import MachinesGrid from "../../components/Machines/MachinesGrid";
import Toolbar from "../../components/Toolbar/Toolbar";

const MachinesIndex = ({classes, machines}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('qualifications.heading_machines')}
            subtitle={`${machines.length} ${i18n.get('qualifications.number_of_machines')}`}
            // items={[
            //     {
            //         icon: 'add',
            //         text: i18n.get('qualifications.new_machine'),
            //         href: `/machines/create`,
            //     }
            // ]}
        />

        <MachinesGrid machines={machines} />
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(MachinesIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/machines/Index.jsx